import { addMessages } from '@hana/i18n';

// Khoá chuỗi danh sách Marketing (MarketingList.tsx) — chỉ phần chrome; tên chiến dịch, mã, khách là dữ liệu.
addMessages('vi', {
  'mk.preview': 'Xem thử', 'mk.previewSoon': 'Xem thử mẫu chưa mở ở bản này', 'mk.closeDock': 'Đóng cột phải',
  'mk.cmp': 'So sánh chiến dịch', 'mk.open': '% mở', 'mk.click': '% bấm', 'mk.hot': 'Khách nóng', 'mk.hotNote': 'Mở nhiều lần hoặc bấm nút CTA',
  'mk.recv': 'Người nhận', 'mk.delivered': 'Đã giao', 'mk.rfq': 'Hỏi giá đối tác', 'mk.retry': 'Thử lại',
});
addMessages('en', {
  'mk.preview': 'Preview', 'mk.previewSoon': 'Template preview is not available yet', 'mk.closeDock': 'Close right panel',
  'mk.cmp': 'Campaign comparison', 'mk.open': '% opened', 'mk.click': '% clicked', 'mk.hot': 'Hot customers', 'mk.hotNote': 'Opened several times or clicked the CTA',
  'mk.recv': 'Recipients', 'mk.delivered': 'Delivered', 'mk.rfq': 'Partner RFQ', 'mk.retry': 'Retry',
});
